/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Link } from '../model';
/**
 * HypermediaApi - axios parameter creator
 * @export
 */
export const HypermediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/hypermedia/ilm/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HypermediaApi - functional programming interface
 * @export
 */
export const HypermediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HypermediaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Link>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HypermediaApi - factory interface
 * @export
 */
export const HypermediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HypermediaApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinks(options?: any): AxiosPromise<Array<Link>> {
            return localVarFp.getLinks(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HypermediaApi - object-oriented interface
 * @export
 * @class HypermediaApi
 * @extends {BaseAPI}
 */
export class HypermediaApi extends BaseAPI {
    /**
     * 
     * @summary Gets links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HypermediaApi
     */
    public getLinks(options?: any) {
        return HypermediaApiFp(this.configuration).getLinks(options).then((request) => request(this.axios, this.basePath));
    }
}
